import * as React from "react"
import { CSSProperties } from "react"
import { CalendarData } from "../EntityType"
import MobileCrmData from "../MobileCrmData"
import { ListItemWrapper } from "../list/ListItemWrapper"
import { ListItemStateContent } from "../list/ListItemStateContent"
import { ListItemCallbackProps, ListMessageCallback } from "../list/MobileListDataWrapper"

export type CalendarDataProps = {
	data: CalendarData, table: string,
	style: CSSProperties,
	index: number,
} & ListItemCallbackProps;

const ItemLeftSide = ( props: CalendarDataProps ) => {
	return <>
		<div className={ "itemFirm ellipsis" }>
			<span dangerouslySetInnerHTML={ { __html: props.data.firmName } } />
		</div>
	</>
}
const ItemRightSide = ( props: CalendarDataProps ) => {
	return <>
		{ props.data.dateFrom
			&& <div className={ "itemDateNextAction ellipsis" }>{ props.data.dateFrom }</div> }
		{
			props.data.permission.assignedUserId.map( ( userId, index ) => (
				<span key={ index }>
					{ MobileCrmData.getUserNameById( userId ) }
				</span>
			) )
		}
	</>
}
const ItemBasic = ( props: CalendarDataProps ) => {
	return <ListItemStateContent statusColor={ props.data.statusColor } statusName={ "" } />
}

export const CalendarListItem = ( props: CalendarDataProps ) => {
	return <ListItemWrapper
		tagColor={ props.data.statusColor }
		name={ props.data.name }
		table={ props.table }
		permission={ props.data.permission }
		id={ props.data.id }
		itemExpandLeftElement={ <ItemLeftSide { ...props } /> }
		itemBasicElement={ <ItemBasic { ...props } /> }
		itemExpandRightElement={ <ItemRightSide { ...props } /> }
		style={ props.style }
		index={ props.index }
		onDeleteItemCallback={ props.onDeleteItemCallback }
		onListMessageCallback={ props.onListMessageCallback }
		onLoadingStart={props.onLoadingStart}
	/>
}
